import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { PopupErrorObject } from '../models/popup-error-object';
import { ReusableActionsUtil } from '../utils/reusable-actions.util';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

// holdings total weight error handler
@Injectable()
export class HoldingsTotalWeightErrorHandlerService extends AbstractErrorHandlerService {

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		let errorCodes = [];
		if (get(error, 'responseJson.errorCodes') && !Array.isArray(error.responseJson.errorCodes)) {
			errorCodes = Object.values(error.responseJson.errorCodes).map(error => error['errorCode']);
		} else {
			errorCodes = get(error, 'responseJson.errorCodes', []);
		}
		if (
			error instanceof PopupErrorObject && errorCodes.includes(ERROR_CODES.HOLDINGS_TOTAL_WEIGHT_ERROR)
		) {
			this.errorMessage = this.contentService.get('HOLDING_WEIGHT_ERROR', ErrorDCR.HOLDING_WEIGHT_ERROR);
			this.errorSeverity = ERROR_SEVERITY.CRITICAL;
			const firstFailedPortfolio = get(error, 'responseJson.resultMap.PORTFOLIOS[0].portfolios', []).find(portfolio => !!portfolio.errorCodes || !portfolio.success);

			console.error(`There was an error while retrieving data for config: ${error.config}\n ${this.errorMessage}`);
			this.trackErrorMessage = 'unabletoprocessrequest';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			const dialogErrorMessage = this.buildErrorMessage();
			dialogErrorMessage.actions = ReusableActionsUtil.generateActions(
				firstFailedPortfolio,
				this.contentService.get('ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL', ErrorDCR.ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL),
				this.contentService.get('ERROR_NEW_ANALYSIS_LABEL', ErrorDCR.ERROR_NEW_ANALYSIS_LABEL)
			);
			this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
